<template>
  <div class="flex h-[100vh] flex-col items-center px-5 pt-[60px]">
    <ClassicNtpDoodle class="relative mb-10 h-48 rounded-[24px]" />
    <ClassicNtpPredictiveSearchbox class="mb-4 w-full" />
    <ClientOnly>
      <ClassicNtpCommonChromeMostVisitedTiles v-if="topSites.length > 0" />
      <MostVisitedTitles v-else />
    </ClientOnly>
  </div>
  <ClassicNtpTagsGoogleTagManager />
</template>

<script setup lang="ts">
  import { useMediaQuery } from '@vueuse/core'
  import { useNewTabPageHead } from '~/composables/useNewTabPageHead'
  import { useTrackPageView } from '~/composables/useTrackPageView'
  import MostVisitedTitles from '~/components/classic/ntp/common/MostVisitedTitles.vue'
  import type { NewTabPage, TopSites } from '~/types/chrome'
  import { useAutoRefresh } from '~/composables/useAutoRefresh'

  useAutoRefresh()

  const updateBodyTheme = (isDark: boolean) => {
    if (isDark) {
      document.body.classList.add('dark')
      document.body.classList.add('bg-[#3c3c3c]')
    } else {
      document.body.classList.remove('dark')
      document.body.classList.remove('bg-[#3c3c3c]')
    }
  }

  const topSites = ref<TopSites[]>([])
  const mostVisited = ref<NewTabPage['mostVisited']>([])

  onBeforeMount(async () => {
    if (process.client) {
      topSites.value = (await window?.chrome?.topSites?.get()) || []
      mostVisited.value = window?.chrome?.embeddedSearch?.newTabPage?.mostVisited || []

      if (topSites.value.length > 0) {
        const darkMode = useMediaQuery('(prefers-color-scheme: dark)')
        watch(darkMode, updateBodyTheme, { immediate: true })
      }
    }
  })

  useNewTabPageHead()
  useTrackPageView()
</script>
